'use client';

import { StoryblokReactComponent } from '@/storyblok/components/componentsMap';
import { PostBookWidgetStoryblok } from '@/storyblok/types';
import { generateServiceLocationUrl } from '@/routes';
import { ELButton } from '@davincihealthcare/elty-design-system-react/dist/ELButton';
import { ArrowRightIcon, CalendarIcon, ClockIcon, ShieldCheckIcon, WalletIcon } from '@heroicons/react/24/outline';
import { useRouter } from 'next/navigation';

export const PostBookWidget: StoryblokReactComponent<PostBookWidgetStoryblok> = ({ component }) => {
  const router = useRouter();

  return (
    <div className="bg-card relative overflow-hidden rounded-2xl border border-neutral-surface/50 shadow-card">
      <div className="h-1.5 bg-secondary" />

      <div className="p-5 sm:p-6 md:p-7">
        <div className="flex items-start gap-4 sm:gap-5">
          <div className="flex size-12 shrink-0 items-center justify-center rounded-2xl bg-secondary text-white shadow-sm sm:size-14">
            <CalendarIcon className="size-6 sm:size-7" />
          </div>

          <div className="mb-6 min-w-0 flex-1">
            <div className="mb-1.5 text-xs font-bold uppercase tracking-widest text-secondary">Hai bisogno di un consulto?</div>
            <h4 className="text-base !font-bold text-neutral-darker sm:text-xl">{component.title}</h4>
            <p className="mt-2 text-sm text-neutral-lighter">{component.description}</p>
          </div>
        </div>

        <div className="mt-5 flex flex-col gap-4 border-t border-primary/15 pt-4 sm:mt-6 sm:flex-row sm:items-center sm:justify-between sm:pt-5">
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-neutral-lighter">
            <span className="inline-flex items-center gap-1.5">
              <ShieldCheckIcon className="size-4 shrink-0" />
              <span>Specialisti verificati</span>
            </span>

            <span className="inline-flex items-center gap-1.5">
              <ClockIcon className="size-4 shrink-0" />
              <span>Disponibilità rapide</span>
            </span>
            <span className="inline-flex items-center gap-1.5">
              <WalletIcon className="size-4 shrink-0" />
              <span>Prezzi trasparenti</span>
            </span>
          </div>

          <ELButton
            label="Prenota una visita"
            variant="floating"
            color="secondary"
            trailingIcon={<ArrowRightIcon className="size-4 stroke-2" />}
            size="small"
            className="text-primary-white h-11 w-full shrink-0 rounded-full bg-secondary px-5 text-sm text-white transition-all hover:bg-secondary-hover sm:w-auto [&>div]:gap-2 [&_span]:font-semibold"
            onClick={() => router.push(generateServiceLocationUrl('treatment', { service: component.speciality }))}
          />
        </div>
      </div>
    </div>
  );
};
